import React, { useState } from "react";
import { Reveal } from "./Reveal";
import { DeckModal } from "./DeckModal";

export const Sponsors = () => {
  const [deckOpen, setDeckOpen] = useState(false);

  return (
    <section id="sponsors" className="relative bg-mds-paper" data-testid="sponsors-section">
      <div className="mx-auto max-w-[1200px] px-5 py-24 sm:px-8 sm:py-32">
        <Reveal className="text-center">
          <p className="mt-2 pb-6 pt-4 font-script text-6xl leading-[1.3] text-gold sm:text-8xl">Thank You to Our Sponsors</p>
          <p className="mx-auto mt-7 max-w-3xl text-balance font-body text-base leading-relaxed text-mds-inksoft">
            Million Dollar Shot is made possible through the extraordinary generosity of the sponsors below. Their
            leadership and investment help bring this unforgettable evening to life while fueling the mission of Naples
            Cancer Advisors. We are deeply grateful for their partnership and invite you to support the businesses and
            organizations whose commitment is helping change lives across Southwest Florida.
          </p>
        </Reveal>

        {/* Sponsor logos */}
        <Reveal delay={0.06}>
          <div className="mt-14 flex flex-col items-center gap-14" data-testid="sponsor-logos">
            {/* Visionary Circle — highest tier (top) */}
            <div className="flex flex-wrap items-center justify-center gap-x-16 gap-y-10 sm:gap-x-24">
            <a
              href="https://www.westernsouthern.com/fortwashington"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col items-center gap-4 transition-opacity duration-300 hover:opacity-70"
              data-testid="sponsor-link-fort-washington"
            >
              <img
                src="/brand/sponsor-fort-washington.webp"
                alt="Fort Washington Investment Advisors, Inc."
                className="h-20 w-auto object-contain sm:h-24"
                draggable={false}
                data-testid="sponsor-logo-fort-washington"
              />
              <span
                className="font-sans text-[11px] font-semibold uppercase tracking-[0.2em] text-mds-gold"
                data-testid="sponsor-category-fort-washington"
              >
                Visionary Circle Sponsor
              </span>
            </a>
            <a
              href="https://www.westernsouthern.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col items-center gap-4 transition-opacity duration-300 hover:opacity-70"
              data-testid="sponsor-link-western-southern"
            >
              <img
                src="/brand/sponsor-western-southern.webp"
                alt="Western & Southern Financial Group"
                className="h-20 w-auto object-contain sm:h-24"
                draggable={false}
                data-testid="sponsor-logo-western-southern"
              />
              <span
                className="font-sans text-[11px] font-semibold uppercase tracking-[0.2em] text-mds-gold"
                data-testid="sponsor-category-western-southern"
              >
                Visionary Circle Sponsor
              </span>
            </a>
            </div>

            {/* Advocate Circle — own line */}
            <a
              href="https://www.agelesselite.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col items-center gap-4 transition-opacity duration-300 hover:opacity-70"
              data-testid="sponsor-link-ageless-elite"
            >
              <img
                src="/brand/sponsor-ageless-elite.webp"
                alt="Ageless Elite"
                className="h-16 w-auto object-contain sm:h-20"
                draggable={false}
                data-testid="sponsor-logo-ageless-elite"
              />
              <span
                className="font-sans text-[11px] font-semibold uppercase tracking-[0.2em] text-mds-gold"
                data-testid="sponsor-category-ageless-elite"
              >
                Advocate Circle Sponsor
              </span>
            </a>

            {/* Supporting sponsors */}
            <div className="flex flex-wrap items-end justify-center gap-x-16 gap-y-10 sm:gap-x-24">
              <a
                href="https://www.theclubatrenaissance.com"
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col items-center gap-4 transition-opacity duration-300 hover:opacity-70"
                data-testid="sponsor-link-club-renaissance"
              >
                <img
                  src="/brand/sponsor-club-renaissance.webp"
                  alt="The Club at Renaissance"
                  className="h-24 w-auto object-contain sm:h-28"
                  draggable={false}
                  data-testid="sponsor-logo-club-renaissance"
                />
                <span
                  className="font-sans text-[11px] font-semibold uppercase tracking-[0.2em] text-mds-gold"
                  data-testid="sponsor-category-club-renaissance"
                >
                  Venue Sponsor &amp; Host
                </span>
              </a>
              <a
                href="https://www.naplesillustrated.com"
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col items-center gap-4 transition-opacity duration-300 hover:opacity-70"
                data-testid="sponsor-link-naples-illustrated"
              >
                <img
                  src="/brand/sponsor-naples-illustrated.webp"
                  alt="Naples Illustrated"
                  className="h-16 w-auto object-contain sm:h-[70px]"
                  draggable={false}
                  data-testid="sponsor-logo-naples-illustrated"
                />
                <span
                  className="font-sans text-[11px] font-semibold uppercase tracking-[0.2em] text-mds-gold"
                  data-testid="sponsor-category-naples-illustrated"
                >
                  Print Media Sponsor
                </span>
              </a>
            </div>

            {/* Keys to Vault + Valet row */}
            <div className="flex flex-wrap items-end justify-center gap-x-16 gap-y-10 sm:gap-x-24">
            <a
              href="https://clivedaniel.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col items-center gap-4 transition-opacity duration-300 hover:opacity-70"
              data-testid="sponsor-link-clive-daniel"
            >
              <img
                src="/brand/sponsor-clive-daniel.webp"
                alt="Clive Daniel Home"
                className="h-24 w-auto object-contain sm:h-28"
                draggable={false}
                data-testid="sponsor-logo-clive-daniel"
              />
              <span
                className="font-sans text-[11px] font-semibold uppercase tracking-[0.2em] text-mds-gold"
                data-testid="sponsor-category-clive-daniel"
              >
                Keys to Vault Sponsor
              </span>
            </a>
            <a
              href="https://stateinsuranceusa.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col items-center gap-4 transition-opacity duration-300 hover:opacity-70"
              data-testid="sponsor-link-state-insurance"
            >
              <img
                src="/brand/sponsor-state-insurance.webp"
                alt="State Insurance USA"
                className="h-16 w-auto object-contain sm:h-[70px]"
                draggable={false}
                data-testid="sponsor-logo-state-insurance"
              />
              <span
                className="font-sans text-[11px] font-semibold uppercase tracking-[0.2em] text-mds-gold"
                data-testid="sponsor-category-state-insurance"
              >
                Valet Sponsor
              </span>
            </a>
            </div>

            {/* Swag Bag + We Carry Hope row */}
            <div className="flex flex-wrap items-end justify-center gap-x-16 gap-y-10 sm:gap-x-24">
            <a
              href="https://www.trademarkroofingllc.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col items-center gap-4 transition-opacity duration-300 hover:opacity-70"
              data-testid="sponsor-link-trademark-roofing"
            >
              <img
                src="/brand/sponsor-trademark-roofing.webp"
                alt="Trademark Roofing"
                className="h-24 w-auto object-contain sm:h-28"
                draggable={false}
                data-testid="sponsor-logo-trademark-roofing"
              />
              <span
                className="font-sans text-[11px] font-semibold uppercase tracking-[0.2em] text-mds-gold"
                data-testid="sponsor-category-trademark-roofing"
              >
                Swag Bag Sponsor
              </span>
            </a>
            <a
              href="https://4everyoungantiaging.com/naples"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col items-center gap-4 transition-opacity duration-300 hover:opacity-70"
              data-testid="sponsor-link-4everyoung"
            >
              <img
                src="/brand/sponsor-4everyoung.webp"
                alt="4Ever Young Anti Aging Solutions"
                className="h-28 w-auto object-contain sm:h-32"
                draggable={false}
                data-testid="sponsor-logo-4everyoung"
              />
              <span
                className="font-sans text-[11px] font-semibold uppercase tracking-[0.2em] text-mds-gold"
                data-testid="sponsor-category-4everyoung"
              >
                We Carry Hope Sponsor
              </span>
            </a>
            </div>
          </div>
        </Reveal>

        <div id="become-sponsor" className="scroll-mt-28" aria-hidden="true" />
        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-col items-center gap-6 rounded-sm border border-mds-line bg-mds-cream p-10 text-center">
            <p className="max-w-2xl font-display text-3xl italic text-mds-ink sm:text-4xl">
              Begin the Legacy. Become a Founding Sponsor of Million Dollar Shot Fort Myers.
            </p>
            <div className="flex flex-col gap-4 sm:flex-row">
              <button
                onClick={() => setDeckOpen(true)}
                className="rounded-full border border-mds-green/40 px-8 py-3.5 font-sans text-[12px] font-semibold uppercase tracking-[0.16em] text-mds-green transition-colors duration-300 hover:border-mds-green hover:bg-mds-green hover:text-mds-cream"
                data-testid="view-deck-secondary"
              >
                Sponsorship Opportunities
              </button>
              <a
                href="https://secure.qgiv.com/event/mdsnaples2026"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full bg-mds-gold px-8 py-3.5 font-sans text-[12px] font-semibold uppercase tracking-[0.16em] text-mds-cream transition-colors duration-300 hover:bg-mds-greendeep"
                data-testid="become-sponsor-cta"
              >
                Become a Sponsor
              </a>
            </div>
          </div>
        </Reveal>
      </div>

      <DeckModal open={deckOpen} onClose={() => setDeckOpen(false)} />
    </section>
  );
};
